
import AnimatedIcon from './AnimatedIcon.vue'

export default {
    components: { AnimatedIcon },
    props: {
        title: {
            required: false,
            default: '',
            type: String
        },
        icon: {
            required: false,
            default: 'fxt-heart',
            type: String
        },
        buttonText: {
            required: false,
            default: 'Neste',
            type: String
        },
        redirectUrl: {
            required: false,
            default: '',
            type: String
        },
        hideButton: {
            required: false,
            default: false,
            type: Boolean
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    methods: {
        redirect(url) {
            window.open(url, '_self')
        }
    }
}
